export default {"src":"/_next/static/media/dragon.b0b88aeb.gif","height":563,"width":1000,"blurWidth":0,"blurHeight":0};